module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ct_no_cn"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pagevii",
      "title": "vii"
    }
  }), _vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "tocfm",
    attrs: {
      "id": "Cov"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Cover"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_c('span', {
    staticClass: "ital"
  }, [_vm._v("Cover")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tocfm2",
    attrs: {
      "id": "Title"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Titlepage"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_c('span', {
    staticClass: "ital"
  }, [_vm._v("Title Page")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tocfm2",
    attrs: {
      "id": "Ded"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Dedication"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_c('span', {
    staticClass: "ital"
  }, [_vm._v("Dedication")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tocfm2",
    attrs: {
      "id": "Map"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Map"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_c('span', {
    staticClass: "ital"
  }, [_vm._v("Tham Luang Cave Complex Map")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tocfm2",
    attrs: {
      "id": "Fig"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Figures"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_c('span', {
    staticClass: "ital"
  }, [_vm._v("Figures Mentioned in")]), _vm._v(" The Boys in the Cave")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocbfm",
    attrs: {
      "id": "Pro"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Prologue"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("Prologue")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocbmp",
    attrs: {
      "id": "P1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Part01"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("Part One")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocbmc",
    attrs: {
      "id": "Chap01"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Ch01"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1")]), _vm._v(": The Moo Pa")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocbmc",
    attrs: {
      "id": "Chap02"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Ch02"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("2")]), _vm._v(": Some Birthday")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocbmc",
    attrs: {
      "id": "Chap03"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Ch03"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("3")]), _vm._v(": “How can I sleep when my son is inside?”")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocbmc",
    attrs: {
      "id": "Chap04"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Ch04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("4")]), _vm._v(": Retreat")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocbmc",
    attrs: {
      "id": "Chap05"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Ch05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("5")]), _vm._v(": “You have one last chance, or the boys will die”")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocbmc",
    attrs: {
      "id": "Chap06"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Ch06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("6")]), _vm._v(": The Foreigners")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocbmc",
    attrs: {
      "id": "Chap07"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Ch07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("7")]), _vm._v(": The Shadow Quartet")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocbmc",
    attrs: {
      "id": "Chap08"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Ch08",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("8")]), _vm._v(": Jungle Bash")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocbmc",
    attrs: {
      "id": "Chap09"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Ch09",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("9")]), _vm._v(": Contact")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocbmp",
    attrs: {
      "id": "P2"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pageviii",
      "title": "viii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/Text/Part02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("Part Two")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocbmc",
    attrs: {
      "id": "Chap10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Ch10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("10")]), _vm._v(": Suicide Mission")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocbmc",
    attrs: {
      "id": "Chap11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Ch11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("11")]), _vm._v(": The Zero-Risk Option")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocbmc",
    attrs: {
      "id": "Chap12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Ch12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("12")]), _vm._v(": Letters Home")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocbmc",
    attrs: {
      "id": "Chap13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Ch13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("13")]), _vm._v(": The Wet Mules")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocbmc",
    attrs: {
      "id": "Chap14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Ch14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("14")]), _vm._v(": Sticking Your Neck Out")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocbmc",
    attrs: {
      "id": "Chap15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Ch15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("15")]), _vm._v(": Getting the Green Light?")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocbmc",
    attrs: {
      "id": "Chap16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Ch16",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("16")]), _vm._v(": D-Day")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocbmc",
    attrs: {
      "id": "Chap17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Ch17",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("17")]), _vm._v(": Like an Egg in a Rock")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocbmc",
    attrs: {
      "id": "Chap18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Ch18",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("18")]), _vm._v(": A Few Shots of Ketamine")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocbmc",
    attrs: {
      "id": "Chap19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Ch19",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("19")]), _vm._v(": The Complacency Gap")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocbmc",
    attrs: {
      "id": "Chap20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Ch20",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("20")]), _vm._v(": Lost")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocbmc",
    attrs: {
      "id": "Chap21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Ch21",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("21")]), _vm._v(": “Life Celebration Party”")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocbmf",
    attrs: {
      "id": "Epi"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Epilogue",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("Epilogue")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm",
    attrs: {
      "id": "Ack"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Acknowledgments",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_c('span', {
    staticClass: "ital"
  }, [_vm._v("Acknowledgments")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tocfm2",
    attrs: {
      "id": "Ill"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PhotoSection",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_c('span', {
    staticClass: "ital"
  }, [_vm._v("Photo Section")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm",
    attrs: {
      "id": "Ata"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Ata",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_c('span', {
    staticClass: "ital"
  }, [_vm._v("About the Author")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm",
    attrs: {
      "id": "Cop"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Copyright",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_c('span', {
    staticClass: "ital"
  }, [_vm._v("Copyright")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm",
    attrs: {
      "id": "Atp"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Atp",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_c('span', {
    staticClass: "ital"
  }, [_vm._v("About the Publisher")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ed6dac92","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Contents.vue
// module id = 72
// module chunks = 0